import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const gethomePageRevisions = async (
  token: string,
  baseUrl: string,
  params = {},
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/home_page_revisions`;

    const res = await get(token, queryPath, params, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
